export default __webpack_public_path__ + "static/media/Shipyards.c6a47837.png";